import { render, staticRenderFns } from "./SecaoGeral.vue?vue&type=template&id=067b5d1e&"
import script from "./SecaoGeral.vue?vue&type=script&lang=js&"
export * from "./SecaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports